import React from "react";
import { Card } from "react-bootstrap";
import "./style.css";

const FeatureCard = ({
  icon,
  title,
  description,
  iconBgColor,
  borderColor,
  delay,
}) => {
  return (
    <Card
      className="feature-card h-100"
      style={{
        minHeight: "210px",
        maxHeight: "210px",
        animationDelay: `${delay}ms`,
        animationFillMode: "forwards",
        borderLeft: `4px solid ${borderColor}`,
      }}
      data-animate="true"
    >
      <Card.Body className="d-flex flex-column">
        <div
          className="feature-icon-wrapper mb-3"
          style={{ backgroundColor: iconBgColor }}
        >
          {icon}
        </div>
        <Card.Title className="feature-title mb-2">{title}</Card.Title>
        <Card.Text className="feature-description">{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default FeatureCard;
